import React, { useCallback, useState } from 'react'

import { Button } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import {
  arrayOf, bool, func, number, shape, string,
} from 'prop-types'

import Modal from 'Pods/Shared/Modal/Modal'

import { candidateKey, spansSeveralArchives } from './candidateKey'
import FileOption from './Components/FileOption/FileOption'

// Lists the model files inside a purchased item's archives so the buyer picks the one to
// open in AI Studio. Labels come from the caller, which owns its page's translations.
function ArchiveFileModal({
  candidates,
  labels,
  isSubmitting = false,
  onSubmit,
  onClose: handleClose,
}) {
  const [selectedKey, setSelectedKey] = useState(null)
  const showArchiveName = spansSeveralArchives(candidates)

  const handleSubmit = useCallback(() => {
    const selected = candidates.find(candidate => candidateKey(candidate) === selectedKey)
    if (selected) onSubmit(selected)
  }, [candidates, selectedKey, onSubmit])

  const footer = (
    <div className="archive-file-modal__actions">
      <Button type="secondary" size="small" actionType="button" onClick={handleClose}>
        {labels.cancel}
      </Button>
      <Button
        type="primary"
        size="small"
        actionType="button"
        disabled={selectedKey === null || isSubmitting}
        aria-busy={isSubmitting}
        onClick={handleSubmit}
      >
        {labels.submit}
      </Button>
    </div>
  )

  return (
    <Modal
      header={labels.title}
      ariaLabel={labels.title}
      width="medium"
      footer={footer}
      customClass="archive-file-modal"
      onClose={handleClose}
    >
      <p className="archive-file-modal__description cgt-body-base">{labels.description}</p>
      <div className="archive-file-modal__list" role="radiogroup" aria-label={labels.listLabel}>
        {candidates.map((candidate) => {
          const key = candidateKey(candidate)
          return (
            <FileOption
              key={key}
              value={key}
              candidate={candidate}
              isSelected={key === selectedKey}
              showArchiveName={showArchiveName}
              onSelect={setSelectedKey}
            />
          )
        })}
      </div>
    </Modal>
  )
}

export const archiveFileCandidateShape = shape({
  itemFileId: number.isRequired,
  entryPath: string.isRequired,
  name: string.isRequired,
  format: string,
  fileSize: number,
  archiveName: string,
})

ArchiveFileModal.propTypes = {
  candidates: arrayOf(archiveFileCandidateShape).isRequired,
  labels: shape({
    title: string.isRequired,
    description: string.isRequired,
    listLabel: string.isRequired,
    submit: string.isRequired,
    cancel: string.isRequired,
  }).isRequired,
  isSubmitting: bool,
  onSubmit: func.isRequired,
  onClose: func.isRequired,
}

export default ArchiveFileModal
